import { styled, Typography } from "@mui/material";

import { Card } from "modules/common/components/Card";

import type { PropsWithChildren, ReactNode } from "react";

export interface ConfiguredCardProps extends PropsWithChildren {
  title: ReactNode;
  button?: ReactNode;
  "data-testid"?: string;
  dropdownNavigation?: ReactNode;
}

export function ConfiguredCard({
  children,
  title,
  "data-testid": dataTestId,
  dropdownNavigation = null,
  button = null,
}: ConfiguredCardProps) {
  return (
    <Card.Wrapper data-testid={dataTestId} variant="elevated" gutterBottom>
      <Card.Body
        header={
          <HeaderWrapper>
            <Typography variant="h6">{title}</Typography>
            <HeaderWrapper>
              {button}
              {dropdownNavigation}
            </HeaderWrapper>
          </HeaderWrapper>
        }
      >
        {children}
      </Card.Body>
    </Card.Wrapper>
  );
}

const HeaderWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: theme.spacing(1.5),
}));
